import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetch } from '../../hooks/useFetch';
import { fetchServices } from '../../api/api';
import axios from 'axios';

const Discuss = () => {
    const { t } = useTranslation();
    const { data: services } = useFetch(["Services"], fetchServices);
    const [submitting, setSubmitting] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        notes: '',
    });

    const [errors, setErrors] = useState({});

    const changeHandler = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setErrors((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        const newErrors = {};
        if (!formData.name) newErrors.name = t('discuss.errors.name');
        if (!formData.email) newErrors.email = t('discuss.errors.email');
        if (!formData.subject) newErrors.subject = t('discuss.errors.subject');
        if (!formData.notes) newErrors.notes = t('discuss.errors.notes');

        setErrors(newErrors);

        // Proceed only if there are no validation errors
        if (Object.keys(newErrors).length === 0) {
            setSubmitting(true);
            try {
                // Prepare data to be sent (excluding errors)
                const { name, email, subject, notes } = formData;
                const dataToSend = { name, email, subject, notes };

                // Simulate API call (replace with your actual API call)
                await axios.post('https://formspree.io/f/xrbgarwv', dataToSend);

                // Reset form data and error states on success
                setFormData({
                    name: '',
                    email: '',
                    subject: '',
                    notes: '',
                });
                setErrors({});
            } catch (error) {
                console.error("Error submitting form:", error);
            } finally {
                setSubmitting(false);
            }
        }
    };

    return (
        <div className="wpo-service-single-item">
            <div className="wpo-service-contact-area">
                <div className="wpo-contact-title">
                    <h2>{t('discuss.title')}</h2>
                    <p>{t('discuss.subtitle')}</p>
                </div>
                <div className="wpo-contact-form-area">
                    <form method="post" onSubmit={submitHandler} className="form">
                        <div className="row">
                            {/* Name Field */}
                            <div className="col col-lg-6 col-md-6 col-12">
                                <div className="form-field">
                                    <input
                                        className="form-control"
                                        value={formData.name}
                                        onChange={changeHandler}
                                        type="text"
                                        name="name"
                                        placeholder={t('discuss.placeholders.name')}
                                    />
                                    <p>{errors.name}</p>
                                </div>
                            </div>
                            {/* Email Field */}
                            <div className="col col-lg-6 col-md-6 col-12">
                                <div className="form-field">
                                    <input
                                        className="form-control"
                                        onChange={changeHandler}
                                        value={formData.email}
                                        type="email"
                                        name="email"
                                        placeholder={t('discuss.placeholders.email')}
                                    />
                                    <p>{errors.email}</p>
                                </div>
                            </div>
                            {/* Subject Field */}
                            <div className="col col-lg-12 col-12">
                                <div className="form-field">
                                    <select
                                        className="form-control"
                                        onChange={changeHandler}
                                        value={formData.subject}
                                        name="subject"
                                    >
                                        <option disabled value="">
                                            {t('discuss.placeholders.services')}
                                        </option>
                                        {services?.data?.data?.map((service, index) => (
                                            <option key={index} value={service?.data?.title}>
                                                {service?.data?.title}
                                            </option>
                                        ))}
                                    </select>
                                    <p>{errors.subject}</p>
                                </div>
                            </div>
                            {/* Notes Field */}
                            <div className="fullwidth col col-lg-12 col-12">
                                <textarea
                                    className="form-control"
                                    name="notes"
                                    id="notes"
                                    placeholder={t('discuss.placeholders.notes')}
                                    value={formData.notes}
                                    onChange={changeHandler}
                                ></textarea>
                                <p>{errors.notes}</p>
                            </div>
                        </div>
                        {/* Submit Button */}
                        <div className="submit-area">
                            <button type="submit" className="theme-btn-s4">
                                {submitting ? t('submittingButton') : t('discuss.submitButton')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Discuss;
